import axiosInstance from "config/axiosConfig";

const API_URL = "/note";

export const fetchNotes = async (resourceId: string, resourceType: string) => {
  try {
    const response = await axiosInstance.get(API_URL, {
      params: { resourceId, resourceType },
    });
    return response.data.notesQueryResponses;
  } catch (error) {
    console.error("Error fetching notes:", error);
    throw error;
  }
};

export const postNote = async (
  resourceId: string,
  resourceType: string,
  note: string
) => {
  try {
    const response = await axiosInstance.post(API_URL, {
      resourceId,
      resourceType,
      notes: note,
    });
    return response.data;
  } catch (error) {
    console.error("Error posting note:", error);
    throw error;
  }
};
